var map = {
	"./admin_settings.png": 1873,
	"./catalog.png": 1874,
	"./catalogWhite.png": 1875,
	"./catalog_orders.png": 1876,
	"./cms.png": 1877,
	"./component-fields/Asset.png": 1878,
	"./component-fields/Blocks.png": 1879,
	"./component-fields/Boolean.png": 1880,
	"./component-fields/Date-time.png": 1881,
	"./component-fields/LInk.png": 1882,
	"./component-fields/Markdown.png": 1883,
	"./component-fields/Multi asset.png": 1884,
	"./component-fields/Multi options.png": 1885,
	"./component-fields/Number.png": 1886,
	"./component-fields/Richtext.png": 1887,
	"./component-fields/Single options.png": 1888,
	"./component-fields/Table.png": 1889,
	"./component-fields/Text area.png": 1890,
	"./component-fields/Text.png": 1891,
	"./components.png": 1892,
	"./configuration.png": 1893,
	"./contents.png": 1894,
	"./crm.png": 1895,
	"./custom_order.png": 1896,
	"./customer_credits.png": 1897,
	"./customer_list.png": 1898,
	"./dashboard.png": 1899,
	"./finance.png": 1900,
	"./home.png": 1901,
	"./integrations.png": 1902,
	"./invoice-list.png": 1903,
	"./layaway.png": 1904,
	"./move.png": 1905,
	"./new_sale.png": 1906,
	"./orders.png": 1907,
	"./payment-methods/amex.png": 1444,
	"./payment-methods/discover.png": 1443,
	"./payment-methods/mastercard.png": 1442,
	"./payment-methods/visa.png": 1441,
	"./payments.png": 1908,
	"./register.png": 1909,
	"./repair_center.png": 1910,
	"./reports.png": 1911,
	"./services.png": 1912,
	"./trade_in_center.png": 1913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1643;